export enum DateRange {
    TODAY = 'TODAY',
    YESTERDAY = 'YESTERDAY',
    THIS_WEEK = 'THIS_WEEK',
    LAST_WEEK = 'LAST_WEEK',
    THIS_MONTH = 'THIS_MONTH',
    LAST_MONTH = 'LAST_MONTH',
    THIS_YEAR = 'THIS_YEAR',
    LAST_YEAR = 'LAST_YEAR'
}



// WEBPACK FOOTER //
// ./src/Models/EnumTypes/FormsEnumTypes.ts